import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=088a7c65&lang=pug&"
import script from "./InfoModal.vue?vue&type=script&lang=js&"
export * from "./InfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/cms/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('088a7c65')) {
      api.createRecord('088a7c65', component.options)
    } else {
      api.reload('088a7c65', component.options)
    }
    module.hot.accept("./InfoModal.vue?vue&type=template&id=088a7c65&lang=pug&", function () {
      api.rerender('088a7c65', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/modal/InfoModal.vue"
export default component.exports